module.exports = __webpack_public_path__ + "img/interac.1dbbaca7.png";